import React from 'react';
import { Todo } from '../types/todo';
import TodoItem from './TodoItem';

interface TodoListProps {
  todos: Todo[];
  onToggleComplete: (todo: Todo) => void;
  onEdit: (todo: Todo) => void;
  onDelete: (id: number) => void;
}

const TodoList: React.FC<TodoListProps> = ({
  todos,
  onToggleComplete,
  onEdit,
  onDelete
}) => {
  if (todos.length === 0) {
    return (
      <div className="todo-empty">
        <div className="todo-empty-icon">📝</div>
        <p>ToDoがありません</p>
        <p>新しいToDoを追加してみましょう！</p>
      </div>
    );
  }

  // 未完了のToDoを先に、完了済みを後に表示
  const sortedTodos = [...todos].sort((a, b) => {
    if (a.completed === b.completed) {
      // 同じ完了状態の場合は期限日でソート（期限が近い順）
      if (a.due_date && b.due_date) {
        return new Date(a.due_date).getTime() - new Date(b.due_date).getTime();
      }
      if (a.due_date) return -1;
      if (b.due_date) return 1;
      return 0;
    }
    return a.completed ? 1 : -1;
  });

  return (
    <div className="todo-list">
      {sortedTodos.map(todo => (
        <TodoItem
          key={todo.id}
          todo={todo}
          onToggleComplete={onToggleComplete}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default TodoList;
